<template>

    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Сообщение об ошибке</template>
        <template v-slot:content>
            <v-layout column сlass="mt-1 mb-2 mx-4">
                <v-form v-model="valid">
                    <v-textarea
                        label="Описание ошибки"
                        placeholder="Как можно подробней опишите ошибку"
                        v-model="errorReport.description"
                        :rules="[rules.required]"
                        rows="7"
                    />
                </v-form>
            </v-layout>
        </template>
        <template v-slot:action>
            <v-btn
                :disabled="!valid"
                @click="sendErrorReport"
            >
                Отправить
            </v-btn>
        </template>
    </dialog-generic>

</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'ErrorReportController',
        props: ['initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                indicator: false,
                valid: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.',
                },
                errorReport: {
                    description: null,
                    user_id: this.$store.getters.currentUser.uid,
                    page: window.location.href
                }
            }
        },
        watch: {
            initialState(value) {
                if (value) {
                    this.visibility = value;
                    this.fillDefault();
                }
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            }
        },
        methods: {
            fillDefault() {
                this.errorReport = {
                    description: null,
                    user_id: this.$store.getters.currentUser.uid,
                    page: window.location.href
                }
            },
            sendErrorReport() {
                let requestData = {
                    login: this.$store.getters.userLogin
                };
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                this.indicator = true;
                this.$http.post(
                    this.$store.getters.endpoint + '/db/report_error', {
                        ...requestData,
                        ...{error_report: this.errorReport}
                    }, {
                        headers: { ...this.$store.state.restrictedHeaders,
                            ...requestHeaders
                        }
                    }
                ).then((r) => {
                    this.indicator = false;
                    this.visibility = false;
                })
            }
        },
    }
</script>
